import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ImageLoad from 'components/ImageLoad';
import ProductFlags from 'components/ProductFlags';
import ProductPrices from 'components/ProductPrices';
import ProductControls from 'components/ProductControls';
import PubSub from 'services/PubSub/';
import notImage from 'images/foto_en_preparacion.png';
import TagManagerService from 'services/TagManager';
import { getImageV2, slugify } from 'utils'
import { withRouter } from "react-router-dom";
import style from './style.scss'; //NOSONAR

let actions = [];
let product = null;
let position = 1;
let title = '';
let id = null;

const ProductPreview = (props) => {
    const [inCart, SetInCart] = useState(0);
    const [preView, setPreView] = useState(false);

    let pricesSettings = {
        promotionDescription: true
    };

    useEffect(() => {
        actions.push(PubSub.register('open_product_preview', (payload) => {
            product = payload.value.product;
            title = payload.value.title;
            position = payload.value.position
            TagManagerService.productClick(product, title, position);
            TagManagerService.productDetail(product, title);
            openPreView();
        }));

        actions.push(PubSub.register('cart_update', _updateInCart));

        return function cleanup() {
            actions = actions.map(token => PubSub.unregister(token));
            actions = [];
            product = null;
        };
    }, []);

    const openPreView = () => {
        document.addEventListener('keydown', _keyDown);
        setPreView(true);
    }

    const _updateInCart = () => {
        if (!(window && window.orderItems && id)) return false;
        const itemData = window.orderItems[id];
        const quantity = itemData ? itemData.quantity : 0;

        if (quantity !== inCart) {
            SetInCart(quantity);
        }
    };

    const closePreView = () => {
        product = null;
        setPreView(false);
        document.removeEventListener('keydown', _keyDown);
    }

    const _keyDown = (data) =>{
        if(data.keyCode === 27){
            closePreView();
        }
    }

    const hasStock = (itemProd) => {
        const commertialOffer = itemProd.sellers[0] ? itemProd.sellers[0].commertialOffer : false;
        return !!(commertialOffer && commertialOffer.ListPrice !== 0 && commertialOffer.AvailableQuantity && commertialOffer.AvailableQuantity >0);
    }

    const goToBrand = (brand) => {
        const formatBrand = slugify(brand);
        props.history.push(`/${formatBrand}`);
        TagManagerService.interaction("Click Marca", brand, product?.categories[0]);
        closePreView()
    }

    if (!product) return '';
    const item = product ? product.items[0] : null;
    const skuData = product.SkuData && item && product.SkuData[item.itemId] ? product.SkuData[item.itemId] : {};
    const link = `/${product.linkText}/p`;
    id = item ? item.itemId : null;

    const productImage = getImageV2(item, 450);
    const hasProductStock = hasStock(item);

    let controlsConfig = item ? {
        buyTitle: "Agregar al carro",
        listButton: true,
        unitMultiplier: item.unitMultiplier,
        measurementUnit: item.measurementUnit,
        maxItems: (item.maxItems * item.unitMultiplier) - inCart,
        maxItemsOrigin: (item.maxItems * item.unitMultiplier),
        tagManagerData: {product, position, listTitle: title},
        addToCartCallback: (quantity) => {
            TagManagerService.addToCart(product, quantity, 'Preview')
        }
    } : {};


    return (
        <div className={'product-preview-container' + (preView ? ' active' : '')}>
            <div className="preview-box">
                <a href={link} className="preview-img">
                    {productImage && <ImageLoad src={productImage} spinner={true} alt={item.name} />}
                    {!productImage && <img src={notImage} />}
                </a>
                <div className="preview-product-info">
                    <i className="close-preView font-icn cross" onClick={closePreView}></i>
                    <div className="product-preview-description">
                        <ProductFlags item={item} nutritionalTag={false} stock={hasProductStock} customTitle="Características principales:"/>
                    </div>
                    <a  href={link} className="product-name">{product.productName}</a>
                    <div className="cont-brand-code">
                        <a className="product-brand" onClick={(()=> goToBrand(product?.brand))}>{product.brand}</a>
                        <span className="product-preview-code">Código de producto: {product.productReference}</span>
                    </div>
                    {hasProductStock && <ProductPrices item={item} skuData={skuData} settings={pricesSettings} productDetail={true} />}
                    {!hasProductStock && <div className={'no-stock'}>
                        <i className={'font-icn alert'}></i>
                        <span className={'no-stock-text'}>En estos momentos, este artículo se encuentra sin stock.</span>
                    </div>}
                    {hasProductStock && item && <ProductControls id={item.itemId} config={controlsConfig} quantity={item.quantity} inCart={item.inCart}/>}
                    <a href={link} className="view-more">
                        <span className="text">Ver más detalles</span><span className="font-icn point-arrow"></span>
                    </a>
                </div>
            </div>
            <div className={'overlay' + (preView ? ' active' : '')} onClick={closePreView}></div>
        </div>
    )
}


ProductPreview.propTypes = {
    listTitle: PropTypes.string,
    position: PropTypes.number
}

export default withRouter(ProductPreview);
